import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { EnquiriesEntity } from "../../enquiries/entites/enquiries";
import {EnquiryProdctsEntity} from '../../enquiries/entites/enquiry-products'

@Entity("mfg_costs")
export class MFGCostsEntity {

    @PrimaryGeneratedColumn('increment',{
        name:"mfg_cost_id"
    }) 
    mfgCostId: number;
    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId: number
   @Column('int',{
    name:'procurement_freight',
    nullable:false
   })
   procurementFrieght: number

   @Column('int',{
    name:'deheading_cost',
    nullable:false
   })
   deheadingCost: number

   @Column('int',{
    name:'peeling_cost',
    nullable:false
   })
   peelingCost: number

   @Column('int',{
    name:'inhouse_labour_cost',
    nullable:false
   })
   inhouseLabourCost: number

   @Column('int',{
    name:'soaking_cost',
    nullable:false
   })
   soakingCost: number

   @Column('int',{
    name:'electricity_cost',
    nullable:false
   })
   electricityCost: number

   @Column('int',{
    name:'boiler_fuel_cost',
    nullable:false
   })
   boilerFuelCost: number

   @Column('int',{
    name:'qc_cost',
    nullable:false
   })
   qcCost: number

   @Column('int',{
    name:'consumable_cost',
    nullable:false
   })
   consumableCost: number

   @Column('int',{
    name:'repairs_and_maintainance',
    nullable:false
   })
   repairsAndMaintainance: number

   @Column('int',{
    name:'other_direct_expences',
    nullable:false
   })
   otherDirectExpences: number

   @Column('int',{
    name:'salaries_and_remunarations',
    nullable:false
   })
   salariesAndRemunarations: number

   @Column('int',{
    name:'depreciation',
    nullable:false
   })
   depreciation: number

   @Column('int',{
    name:'finance_cost',
    nullable:false
   })
   financeCost: number

   @Column('int',{
    name:'admin_and_other_cost',
    nullable:false
   })
   adminAndOtherCost: number

   @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.mfgCosts )
    @JoinColumn({name:'enquiry_id'})
    enquiryEntity:EnquiriesEntity

    @ManyToOne(() => EnquiryProdctsEntity,endProd =>endProd.mfgCosts )
    @JoinColumn({name:'enquiry_product_id'})
    enquiryProducts:EnquiryProdctsEntity

}